export enum SelectMode {
    None = 0,
    Single = 1,
    Multiple = 2
}